import React, { useState } from 'react';
import Lightbox from './Lightbox';

export default function MosaicGrid({ photos, gap = 2 }) {
  const [selected, setSelected] = useState(null);

  if (!photos || photos.length === 0) {
    return (
      <div style={{
        padding: '6rem 2.5rem',
        color: 'var(--ink-faint)',
        fontSize: '13px',
      }}>
        No photographs yet.
      </div>
    );
  }

  return (
    <>
      <div style={{
        columns: 'var(--mosaic-cols, 3)',
        columnGap: `${gap}px`,
        lineHeight: 0,
      }}>
        {photos.map((photo, i) => (
          <div
            key={photo.id}
            onClick={() => setSelected(i)}
            style={{
              display: 'inline-block',
              width: '100%',
              marginBottom: `${gap}px`,
              cursor: 'pointer',
              overflow: 'hidden',
            }}
          >
            <img
              src={photo.url}
              alt={photo.filename || ''}
              loading="lazy"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                transition: 'opacity 200ms',
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            />
          </div>
        ))}
      </div>

      {selected !== null && (
        <Lightbox
          photos={photos}
          index={selected}
          onClose={() => setSelected(null)}
          onChange={setSelected}
        />
      )}
    </>
  );
}
